import { PermissionAccess } from '@symfa-inc/providence-verizon-types';

export const canBeEditable = (
  fieldPermission: PermissionAccess,
  isEditing?: boolean,
): boolean =>
  fieldPermission ? !!isEditing : !!isEditing && !!fieldPermission;
